<template>
  <div class="main-container">
    <div class="search-box min">
      <div class="input-item">
        <span class="label">商品名称</span>
        <Input type="text" v-model="searchParams.svcName" placeholder="请输入" clearable @on-enter="searchAjax()"/>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <!-- 商品名称 -->
        <template slot-scope="{ row }" slot="svcName">
          <span @click="$refs.serviceDetail.open(row)" class="table-btn"> {{ row.svcName }} </span>
        </template>
        <!-- 类型 -->
        <template slot-scope="{ row }" slot="svcCate">
          <span @click="$refs.typeDetail.open(row)" class="table-btn"> {{ row.svcCate }} </span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <span @click="exchange(row)" class="table-btn" v-if="pageType == 1"> 兑换 </span>
          <span @click="$refs.serviceDetail.open(row)" class="table-btn" v-else> 查看 </span>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
    </div>
    <!-- 详情 -->
    <service-detail ref="serviceDetail" @reload="reload" />
    <!-- 服务类型详情 -->
    <type-detail ref="typeDetail" @reload="reload" />
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import serviceDetail from './components/serviceDetail';
import typeDetail from './components/typeDetail';
import confirmModal from '@/components/commons/confirmModal';
import { pageTool, common } from '@/api/mixins';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, common, config],
  components: {
    serviceDetail,
    typeDetail,
    confirmModal
  },
  data() {
    return {
      pageType: '1',// 1:周边服务 2:增值服务
      searchParams: {}
    };
  },
  watch: {},
  computed: {},
  mounted() {
    this.pageType = this.$route.params.pageType || '1';
    if(this.pageType == '2'){
      this.setPageTitle('增值服务');
    }
    this.initListParams('/buz/extSvc/page');
  },
  activated() {
    this.getList();
  },
  methods: {
    reload() {
      this.selectArr = [];
      this.isAll = false;
      this.getList();
    },
    // 设置参数
    setListParams(params) {
      this.getColumns();
      params.type = this.pageType;// 1:周边服务 2:增值服务
    },
    // 兑换
    exchange(row) {
      this.openPageTabTags('/servicesManager/order/editForm', {
        svcId: row.id || '',
        time: new Date().getTime(),
        backUrl: '/servicesManager/search'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
